// ResponsivePaymentSortant.jsx → src/gestion-payments/
import React from "react";
import PaymentSortant from "./PaymentSortant";
import PaymentsMobile from "../mobile/paiements/PaymentsMobile";
import useIsMobile from "../hooks/useIsMobile";

export default function ResponsivePaymentSortant(props) {
  return useIsMobile() ? <PaymentsMobile paymentType="out" {...props} /> : <PaymentSortant {...props} />;
}
